import { api, ApiRequestConfig } from '../../../api';

type TFetchCategories = {
	regionCode: string;
};

export const fetchTopCategories = (
	url: string,
	params: TFetchCategories,
	config?: ApiRequestConfig
) => api.get(url, params, config);
